import type { RiskObjectGroups, ROLegalMinimal } from '../types';

const GROUPS: RiskObjectGroups<ROLegalMinimal> = [
  {
    title: 'RO_SECTION_OVERVIEW',
    properties: [
      {
        label: 'RO_LEGAL_NAME',
        getValue: (legal) => legal.name,
      },
      {
        label: 'RO_LEGAL_HOUSEHOLD',
        getValue: (legal) => legal.status,
      },
      {
        label: 'RO_LEGAL_NUMBER_OF_VEHICLES',
        getValue: (legal) => legal.number_of_vehicles,
      },
      // {
      //   label: 'RO_LEGAL_UNDERAGE_CHILDREN',
      //   getValue: (legal) =>
      //     legal.has_underage_children && yesNo(legal.has_underage_children),
      // },
    ],
  },
];

export default GROUPS;
